import { createElement, Component } from "react";
import { Subject } from "rxjs/Subject";
import { startWith } from "rxjs/operators/startWith";

const mapPropsStream = (project) => (wrappedComponent) =>
  class MapPropsStream extends Component {
    state = { mappedProps: undefined };
    props$ = new Subject();

    UNSAFE_componentWillMount() {
      this.subscription = this.props$
        .pipe(startWith(this.props), project)
        .subscribe((mappedProps) => {
          this.setState({ mappedProps });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      this.props$.next(nextProps);
    }

    shouldComponentUpdate(props, state) {
      return this.state.mappedProps !== state.mappedProps;
    }

    componentWillUnmount() {
      this.subscription.unsubscribe();
    }

    render() {
      return this.state.mappedProps === undefined
        ? null
        : createElement(wrappedComponent, this.state.mappedProps);
    }
  };

export default mapPropsStream;
